<script lang="ts">
    export let price: number
</script>
{#if price === 0}
    0.00
{:else}
    {price.toFixed(2)}
{/if}